import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  min-height: calc(100dvh - 68px);
  display: flex;
  justify-content: center;

  @media (min-width: 1024px) {
    align-items: center;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  justify-content: center;
  align-items: center;
  height: fit-content;

  h1 {
    color: #111;
    text-align: center;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }

  p {
    color: #111;
    text-align: center;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;
